import { parseDateOnly } from "@design-system/DatePicker/DatePicker.lib";

/** A valid `YYYY-MM-DD` calendar day, else null. Never reads timestamps. */
export const asDateOnly = <TValue>(value: TValue): string | null =>
    typeof value === "string" && parseDateOnly(value) !== undefined
        ? value
        : null;
